import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: auto;
  color: ${({ theme }) => theme.palette.grey1100};
  position: relative;
`;

export const Title = styled.h2`
  font-size: 28px;
  font-weight: 700;

  color: ${({ theme }) => theme.palette.grey1100};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
  }
`;
export const TitleAnnouncement = styled.h2`
  font-size: 18px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.grey1100};
`;
export const Wrapper = styled.div``;
